<div class="modal fade" id="{{modalId}}" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div *ngIf="pageLoading1" class="loader text-center">
				<img src="../../assets/img/loading.gif" />
				<p style="color: black;font-weight: bolder;">Loading...</p>
			</div>
			<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
				<div class="modal-header text-center row g-1">
					<h4 class="modal-title mb-0 col-11 text-start">
						<strong>
							{{uId ? "Edit Leave" : "Add Leave"}}
						</strong>
					</h4>
					<div class="col-1 text-end">
						<button type="button" class="btn-close" (click)="clearForm();"></button>
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<div class="row mb-3">
								<div class="col-4">
									<div class="ng-select-material">
										<ng-select [items]="userList" bindValue="emp_code" bindLabel="full_name"
											[clearable]="true" placeholder="Employee*" formControlName="emp_code"
											id="emp_code_leave" appearance="outline"
											[ngClass]="{'is-invalid':showError('emp_code')}">
										</ng-select>
									</div>
									<p *ngIf="showError('emp_code')" class="text-danger">
										<span *ngIf="f.emp_code.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-2">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control"
												[ngClass]="{'is-invalid':showError('from_date')}" placeholder=""
												formControlName="from_date" ngbDatepicker id="from_date_leave"
												#from_date="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
											<label>From*</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="from_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<p *ngIf="showError('from_date')" class="text-danger">
										<span *ngIf="f.from_date.errors?.required">
											Required
										</span>
										<span *ngIf="f.from_date.errors?.ngbDate">
											Invalid
										</span>
									</p>
								</div>
								<div class="col-2">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control" [ngClass]="{'is-invalid':showError('to_date')}"
												placeholder="YYYY-MM-DD" formControlName="to_date" ngbDatepicker
												id="to_date_leave" #to_date="ngbDatepicker" [minDate]="minDate"
												[container]="'body'" />
											<label>To*</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="to_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<p *ngIf="showError('to_date')" class="text-danger">
										<span *ngIf="f.to_date.errors?.required">
											Required
										</span>
										<span *ngIf="f.to_date.errors?.ngbDate">
											Invalid
										</span>
									</p>
								</div>
								<div class="col-2">
									<div class="ng-select-material">
										<ng-select [items]="typeList" bindValue="id" bindLabel="type" [clearable]="true"
											placeholder="Leave Type*" formControlName="type" id="type_leave"
											appearance="outline" [ngClass]="{'is-invalid':showError('type')}">
										</ng-select>
									</div>
									<p *ngIf="showError('type')" class="text-danger">
										<span *ngIf="f.type.errors?.required">
											Required
										</span>
									</p>
								</div>
								@if(navbar.user?.tms_access?.leave_module && uId){
								<div class="col-2">
									<mat-checkbox [color]="'primary'" formControlName="is_approved"
										id="is_approved_leave">
										Approved
									</mat-checkbox>
								</div>
								}
							</div>
							<div class="row mb-3">
								<div class="col-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError('reason')}"
											id="reason_leave" formControlName="reason" placeholder="">
										<label>Reason*</label>
									</div>
									<p *ngIf="showError('reason')" class="text-danger">
										<span *ngIf="f.reason.errors?.required">
											Required
										</span>
									</p>
								</div>
							</div>
							@if(get_rows.length){
							<div class="row g-0 mb-3 row-container">
								<div class="col-3 border row-date-padding text-center" formArrayName="line_items"
									*ngFor="let creds of get_rows.controls; let i = index">
									<ng-container [formGroupName]="i">
										<strong [ngClass]="getDateClass(i)">
											{{getWeekDay(creds.get('date')?.value)}}
											{{getRowDateString(creds.get('date')?.value)}}
										</strong>
										<button type="button" class="btn btn-xs btn-danger float-end"
											matTooltip="Remove" (click)="deleteRow(i)">
											<fa-icon [icon]="['fas','times']"></fa-icon>
										</button>
										<div class="full-half-radio-container">
											<mat-radio-group formControlName="is_half">
												<mat-radio-button [value]="false" [color]="'primary'">
													Full Day
												</mat-radio-button>
												<mat-radio-button [value]="true" [color]="'primary'">
													Half Day
												</mat-radio-button>
											</mat-radio-group>
											<p *ngIf="showError2(i,'is_half')" class="text-danger">
												<span *ngIf="creds.get('is_half')?.errors?.required">
													Required
												</span>
											</p>
											<p *ngIf="showError3(i,'date')" class="text-danger">
												<span *ngIf="creds.get('date')?.errors?.holiday">
													Holiday
												</span>
											</p>
										</div>
									</ng-container>
								</div>
							</div>
							}
						</div>
					</div>
				</div>
				<div class="modal-footer">
					@if(f.from_date.value && f.to_date.value && get_rows.length){
					<strong>
						{{getDays()}}
					</strong>
					}
					<button type="submit" class="btn btn-sm btn-primary me-1">
						<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						Submit
					</button>
					<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
				</div>
			</form>
		</div>
	</div>
</div>